import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useContext } from 'react';
import { Button } from 'semantic-ui-react';
import _get from 'lodash/get';
import { PREVIOUS_DIRECTION, NEXT_DIRECTION } from './PaginatedArrow.constants';
import { getDirectionHandler, getDefaultDirectionIcon } from './PaginatedArrow.utils';
import { GoogleAnalytics } from '../../../../../../services/analytics';
import { EVENT_ACTIONS } from '../../../../../analytics/components/Event/Event.constants';
import Icon from '../../../Icon/Icon';
import { PaginationContext } from '../../contexts/pagination';
var defaultProps = {
  children: null,
  icon: ''
};
export default function PaginationArrow(_ref) {
  var direction = _ref.direction,
    children = _ref.children,
    iconProp = _ref.icon;
  var _useContext = useContext(PaginationContext),
    pagination = _useContext.pagination,
    event = _useContext.event;
  var onPreviousPage = pagination.onPreviousPage,
    onNextPage = pagination.onNextPage,
    totalPages = pagination.totalPages;
  if (totalPages <= 1) {
    return null;
  }
  function handleDirectionClick() {
    var category = _get(event, 'category');
    var action = EVENT_ACTIONS.PAGINATION_ARROW_EVENT_ACTION;
    GoogleAnalytics.event(category, action, {
      label: direction
    });
    return getDirectionHandler(direction, {
      next: onNextPage,
      previous: onPreviousPage
    });
  }
  var icon = iconProp || getDefaultDirectionIcon(direction);
  var defaultButton = /*#__PURE__*/React.createElement(Button, {
    icon: true,
    "aria-label": direction
  }, /*#__PURE__*/React.createElement(Icon, {
    iconName: icon
  }));
  var finalButton = children || defaultButton;
  return /*#__PURE__*/React.cloneElement(finalButton, _objectSpread(_objectSpread({}, finalButton.props), {}, {
    onClick: function onClick() {
      return handleDirectionClick()();
    }
  }));
}
PaginationArrow.defaultProps = defaultProps;